import React from "react";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <div className="wrapper--narrow section-padding">
      <div className="text__standard text-left">
        <h1 className="h2">Cookie Policy</h1>
        <div className="rte body-size-5">
          <p>Last updated September 8, 2026</p>
          <p>
            This Cookie Policy explains how Sacuddin uses cookies and similar
            technologies when you visit sacuddin.shop. It should be read with
            our Privacy Policy.
          </p>

          <h2>What cookies are</h2>
          <p>
            Cookies are small text files stored by your browser. Similar local
            storage technologies may also remember information between visits.
          </p>

          <h2>How we use them</h2>
          <ul>
            <li>
              <strong>Essential:</strong> to operate checkout, retain cart
              selections, provide security, and remember privacy choices.
            </li>
            <li>
              <strong>Preferences:</strong> to remember settings you select.
            </li>
            <li>
              <strong>Analytics:</strong> to understand site performance and
              improve navigation using aggregated usage information.
            </li>
            <li>
              <strong>Marketing:</strong> where enabled and permitted, to
              measure campaigns and make promotions more relevant.
            </li>
          </ul>

          <h2>Your choices</h2>
          <p>
            You can block or delete cookies through your browser settings.
            Disabling essential cookies may prevent the cart or checkout from
            working correctly. Where a cookie preference control is displayed,
            you can also use it to change optional-cookie choices.
          </p>

          <h2>Third-party services</h2>
          <p>
            Payment, hosting, security, delivery, or analytics providers may
            place cookies when they supply services to us. Their use of data is
            governed by their own notices and our agreements with them.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about cookies can be sent to{" "}
            <a href="mailto:kit@sacuddin.shop">kit@sacuddin.shop</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy;
